var exports = {
  "kL": "xfb577c5e--c9709c--container",
  "wm": "xfb577c5e--c9709c--logo",
  "yr": "xfb577c5e--c9709c--logo-image",
  "ot": "xfb577c5e--c9709c--logo-icon",
  "Qs": "xfb577c5e--c9709c--content",
  "md": "xfb577c5e--c9709c--nowrap-text",
};

module.exports = exports;
